export default "__VITE_ASSET__f1bd41a9__"